export default __webpack_public_path__ + "static/media/Reimbursement.9f5f6811.svg";